import { _data, DriverModel, AddressModel } from './data.tyre.js';
import { _utilities } from '../utilities.js';
import Common from '../i247.Common.js';

let DriverPanel = function () {
	// -------------------------------------------------------------------------------
	//  Private members
	// -------------------------------------------------------------------------------

	var BindControls = function () {
		$('#Driver_Title').kendoDropDownList({
			dataSource: {
				transport: {
					read: {
						url: '/Driver/GetAllDriverTitles'
					}
				}
			},
			dataTextField: 'text',
			dataValueField: 'value'
		});
		$('#CheckBoxSendSMSConfirmation').change(function () {
			if (this.checked) {
				$('#Mobile').attr('required', 'required');
			} else {
				$('#Mobile').removeAttr('required');
				Common.RemoveValidationStyles($('#Mobile'));
			}
		});
	};

	// -------------------------------------------------------------------------------
	//  Public members
	// -------------------------------------------------------------------------------

	return {
		InitializePanel: function () {
			BindControls();
		},
		SaveDriverDetails: function () {
			let $panel = $('#driverDetailsSection');
			let driverAddress = new AddressModel();

			if (!_data.driver || _data.driver.postcode === undefined || _data.driver.postcode === null) {
				driverAddress.name = $panel.find('input[id$="Address_Name"]').val();
				driverAddress.line1 = $panel.find('input[id$="Address_AddressLine1"]').val();
				driverAddress.line2 = $panel.find('input[id$="Address_AddressLine2"]').val();
				driverAddress.town = $panel.find('input[id$="Address_Town"]').val();
				driverAddress.county = $panel.find('input[id$="Address_County"]').val();
				driverAddress.postcode = $panel.find('input[id$="Postcode"]').val();
			}

			_data.driver = new DriverModel(
				$panel.find('input[id="Driver_Title"]').val(),
				$panel.find('input[id="Driver_MainFirstName"]').val(),
				$panel.find('input[id="Driver_MainSurname"]').val(),
				$panel.find('input[id="Mobile"]').val(),
				$panel.find('input[id="AlternativePhone"]').val(),
				$panel.find('input[id="Email"]').val(),
				$panel.find('input[name="CheckBoxSendSMSConfirmation"]').is(':checked'),
				driverAddress,
				$panel.find('#PrivacyCheckBox').is(':checked'),
				(_utilities.IsMfs() || _utilities.IsVMS())
					? $panel.find('textarea[id="AdditionalInformation"]').val()
					: null
			);
		},
		getDriverDetailValidator: function () {
			return $('#driverDetailsSlide').kendoValidator({
				rules: {
					mandatoryMobileNumber: function (input) {
						// check if 'text message' is selected and if so make sure a mobile is provided
						if (input.is('#PreferredContactMethodSms')) {
							var textMessageChecked = $('#PreferredContactMethodSms').is(':checked');
							var mobileNumberProvided = _utilities.CheckIfMobilePhoneProvided([$('#Mobile'), $('#AlternativePhone')]);
							if (textMessageChecked && !mobileNumberProvided) {
								return false;
							}
						}
						return true;
					},
					preferredMethodOfContact: function (input) {
						if (input.is('#PreferredContactMethodSms')) {
							var textMessageChecked = $('#PreferredContactMethodSms').is(':checked');
							var emailMessageChecked = $('#PreferredContactMethodEmail').is(':checked');
							if (!textMessageChecked && !emailMessageChecked) {
								return false;
							}
						}
						return true;
					},
					dataPrivacyPolicyChecked: function (input) {
						if (input.is('#PrivacyCheckBox')) {
							let privacyPolicyChecked = $('#PrivacyCheckBox').is(':checked');
							if (!privacyPolicyChecked) {
								return false;
							}
						}
						return true;
					}
				},
				messages: {
					mandatoryMobileNumber: 'Please enter a valid mobile phone in order to receive text notification.',
					preferredMethodOfContact: 'Select a preferred contact method.'
				}
			}).data('kendoValidator');
		},
		getDataPrivacyValidator: function () {
			return $('#DataProtectionSlide').kendoValidator({
				rules: {
					dataPrivacyPolicyChecked: function (input) {
						if (input.is('#PrivacyCheckBox')) {
							let privacyPolicyChecked = $('#PrivacyCheckBox').is(':checked');
							if (!privacyPolicyChecked) {
								return false;
							}
						}
						return true;
					}
				},
				messages: {
					dataPrivacyPolicyChecked: 'You must accept the privacy policy in order to continue'
				}
			}).data('kendoValidator');
		}
	};
};

export let _driverPanel = new DriverPanel();
